module.exports = __webpack_public_path__ + "img/logo.ba2be3f2.svg";